import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { RectangleIntegrationIcon } from '../RectangleIntegrationIcon/RectangleIntegrationIcon'
import { BendingArrowIcon } from './BendingArrowIcon'
import { CheckMark } from './CheckMark'
import { getIntegrationColor } from '../integrationColors'
import './IntegrationSavedIconCombo.scss'

export const IntegrationSavedIconCombo: React.FC<{ serviceId: IntegrationServiceId }> = ({ serviceId }) => {
  return (
    <div className='integration-saved-icon-combo'>
      {/* Zocks icon - top left */}
      <div className='icon-top-left'>
        <RectangleIntegrationIcon serviceId={'Zocks'} />
      </div>

      {/* Integration icon - bottom right with checkmark overlay */}
      <div className='icon-bottom-right'>
        <div className='icon-relative'>
          <RectangleIntegrationIcon serviceId={serviceId} />

          <div className='checkmark-overlay' style={{ '--checkmark-stroke': getIntegrationColor(serviceId) } as React.CSSProperties}>
            <CheckMark stroke={getIntegrationColor(serviceId)} />
          </div>
        </div>
      </div>

      {/* Left arrow - points from Zocks to Integration */}
      <div className='arrow-bottom-left'>
        <BendingArrowIcon facing={'left'} />
      </div>

      {/* Right arrow - points from Integration to Zocks */}
      <div className='arrow-top-right'>
        <BendingArrowIcon facing={'right'} />
      </div>
    </div>
  )
}
